module.exports = __webpack_public_path__ + "img/csgot.8d5dbe84.png";